var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card-body" }, [
      _c("form", { staticClass: "pt-4 pb-4 pl-4 pr-4" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input1" } }, [_vm._v("Tipo")]),
              _vm._v(" "),
              _c("base-select", {
                staticStyle: { "font-size": "12px" },
                attrs: {
                  options: _vm.tipoOptions,
                  searchable: true,
                  "allow-empty": false,
                  "show-labels": false,
                  label: "label",
                  "track-by": "id",
                },
                model: {
                  value: _vm.form.tipo,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "tipo", $$v)
                  },
                  expression: "form.tipo",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input2" } }, [
                _vm._v("Periodicidad"),
              ]),
              _vm._v(" "),
              _c("base-select", {
                staticStyle: { "font-size": "12px" },
                attrs: {
                  options: _vm.periodicidadOptions,
                  searchable: true,
                  "allow-empty": false,
                  "show-labels": false,
                  label: "label",
                  "track-by": "id",
                },
                model: {
                  value: _vm.form.periodicidad,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "periodicidad", $$v)
                  },
                  expression: "form.periodicidad",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input3" } }, [_vm._v("Periodo")]),
              _vm._v(" "),
              _c("base-input", {
                model: {
                  value: _vm.form.periodo,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "periodo", $$v)
                  },
                  expression: "form.periodo",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input4" } }, [_vm._v("Ejercicio")]),
              _vm._v(" "),
              _c("base-select", {
                staticStyle: { "font-size": "12px" },
                attrs: {
                  options: _vm.ejercicioOptions,
                  searchable: true,
                  "allow-empty": false,
                  "show-labels": false,
                  label: "label",
                  "track-by": "id",
                },
                model: {
                  value: _vm.form.ejercicio,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "ejercicio", $$v)
                  },
                  expression: "form.ejercicio",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input1" } }, [
                _vm._v("Saldo a Aplicar"),
              ]),
              _vm._v(" "),
              _c("base-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.form.saldoAplicar,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "saldoAplicar", $$v)
                  },
                  expression: "form.saldoAplicar",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input2" } }, [
                _vm._v("Tipo de Declaración ˅"),
              ]),
              _vm._v(" "),
              _c("base-select", {
                staticStyle: { "font-size": "12px" },
                attrs: {
                  options: _vm.declaracionOptions,
                  searchable: true,
                  "allow-empty": false,
                  "show-labels": false,
                  label: "label",
                  "track-by": "id",
                },
                model: {
                  value: _vm.form.tipoDeclaracion,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "tipoDeclaracion", $$v)
                  },
                  expression: "form.tipoDeclaracion",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input3" } }, [
                _vm._v("Número de Operación"),
              ]),
              _vm._v(" "),
              _c("base-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.form.numeroOperacion,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "numeroOperacion", $$v)
                  },
                  expression: "form.numeroOperacion",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-3" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input5" } }, [
                _vm._v("Monto Original del Saldo a Favor"),
              ]),
              _vm._v(" "),
              _c("base-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.form.montoOriginal,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "montoOriginal", $$v)
                  },
                  expression: "form.montoOriginal",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input7" } }, [
                _vm._v("Remanente Historico Antes de la Aplicación"),
              ]),
              _vm._v(" "),
              _c("base-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.form.remanenteHistorico,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remanenteHistorico", $$v)
                  },
                  expression: "form.remanenteHistorico",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-3" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input5" } }, [
                _vm._v("Fecha en que se presento el Saldo a Favor"),
              ]),
              _vm._v(" "),
              _c("base-date-picker", {
                attrs: {
                  "calendar-button": true,
                  "calendar-button-icon": "calendar",
                  typeable: true,
                },
                model: {
                  value: _vm.form.fecha,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "fecha", $$v)
                  },
                  expression: "form.fecha",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { attrs: { for: "input7" } }, [
                _vm._v("Remanente Actualizado Antes de la Aplicación"),
              ]),
              _vm._v(" "),
              _c("base-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.form.remanenteActualizado,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remanenteActualizado", $$v)
                  },
                  expression: "form.remanenteActualizado",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [
      _c(
        "div",
        { staticClass: "mt-2 flex-content-right" },
        [
          _c(
            "base-button",
            { attrs: { color: "theme" }, on: { click: _vm.saveCompensacion } },
            [_vm._v("\n        Aplicar Saldo\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }